import React from "react";

type StatsType = {
  title: string;
  description: string;
  number: string;
};

const stats: StatsType[] = [
  {
    title: "Years of experience",
    description:
      "Lorem ipsum dolor sit amet consectetur. Vitae ultricies risus vel aliquam sit facilisis. Turpis magna nibh pulvinar quis.",
    number: "25+",
  },
  {
    title: "Client Satisfaction",
    description:
      "Lorem ipsum dolor sit amet consectetur. Vitae ultricies risus vel aliquam sit facilisis. Turpis magna nibh pulvinar quis.",
    number: "99%",
  },
  {
    title: "Awards Won",
    description:
      "Lorem ipsum dolor sit amet consectetur. Vitae ultricies risus vel aliquam sit facilisis. Turpis magna nibh pulvinar quis.",
    number: "80+",
  },
];

const Stats = () => {
  return (
    <div className="py-6 bg-[#1E1E1E] text-white jost-regular w-full sm:py-20 mx-4 sm:mx-12 flex flex-col md:flex-row gap-5 sm:gap-10 justify-center items-center">
      <div className="grid lg:grid-cols-2 xl:grid-cols-3 gap-4 w-full px-4">
        {stats.map((item) => (
          <div
            className="flex flex-col max-w-[450px] sm:border-l border-white sm:pl-10 border-opacity-20"
            key={item.title}
          >
            <h3 className="text-xl sm:text-3xl">{item.title}</h3>
            <p className="opacity-50 max-w-[350px] mt-4">{item.description}</p>
            <h1 className="text-2xl sm:text-4xl mt-10">{item.number}</h1>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Stats;
